/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function () {
    // Sticky Header
    var $header =
        $('.shopify-section--header');

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 26) {
            $header.addClass('header-sticky');
        } else {
            $header.removeClass('header-sticky');
        }
    })

    $('button.header__icon-wrapper.tap-area[aria-controls="mobile-menu-drawer"]').click(function () {
//     $header.toggleClass('header-transparent');

    })


    $('.c-article-her-styling__thumbnail--carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        appendArrows: '.c-article-her-styling__thumbnail--arrow',
        dots: false,
        draggable: true,
//         autoplay: true,
//         autoplaySpeed: 1000,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    })

    var checkExist = setInterval(function () {
        var $item = $('.c-article-her-styling__thumbnail--carousel.slick-initialized');
        if ($item.length) {
            console.log("Exists!");
            clearInterval(checkExist);
            $('.c-article-her-styling__thumbnail--loading').hide();
            $('.c-article-her-styling__thumbnail--carousel.slick-initialized').show();
            $('.c-article-her-styling__thumbnail--arrow').show();
            $('.c-article-her-styling__thumbnail--carousel.slick-initialized').slick('setPosition');
        }
    }, 100); // check every 100ms


    //     BLOG ARCHIVE MASONRY
    $('.shopify-section--main-blog:not(.custom-blog-template) .article-list').masonry({
        itemSelector: '.article-item',
        horizontalOrder: true
    });

    $('.c-blog-posts .article-list').masonry({
        itemSelector: '.c-blog-posts__item',
        horizontalOrder: true
    });


    $('.footer__button').click(function () {
        $(this).toggleClass('is-active');
        $(this).parent('.footer__buttonBox').next().slideToggle("slow");
    })

    $('.account__button').click(function () {
        $(this).parent('.account__buttonBox').next().slideToggle("slow");
    })

    if ($('.template-collection').length > 0) {
        if ($('image-with-text-overlay').length > 0) {
            $('store-header').attr('transparent', '');
            $('store-header').addClass('header--transparent');
        }
        var $storeHeader = $('store-header');

        $(window).scroll(function () {
            if ($(window).scrollTop() >= 26) {
                $storeHeader.removeClass('header--transparent');
            } else {
                $storeHeader.addClass('header--transparent');
            }
        })
    }


    $('.js-featured-collection-tabs__productBox').each(function () {
        var $slider = $(this);
        var $progressBar = $(this).parents('.c-featured-collection-tabs__productList').find('.c-featured-collection-tabs__progress');
        var $progressBarLabel = $(this).parents('.c-featured-collection-tabs__productList').find('.c-featured-collection-tabs__label');

        $slider.on('init', function (event, slick, currentSlide, nextSlide) {

            var calc = ((1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick.slideCount, slick.options.slidesToShow);
            var calc = ((nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });


        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            draggable: true,
            responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true
                }
            }],
            cssEase: 'linear'//開始から終了まで一定に変化する
        })
    })

    $('.js-featured-collection-tabs__tabItem').click(function () {
        var $ariaControl = $(this).attr('aria-controls');
        var $productBox = $('#' + $ariaControl);
        $('.c-featured-collection-tabs__productList').removeClass('is-active');
        $('.c-featured-collection-tabs__tabItem').removeClass('is-active');
        $(this).addClass('is-active');
        $productBox.addClass('is-active');
        $productBox.find('.c-featured-collection-tabs__productBox').slick('setPosition');
    })

    if ($('.product-form__descriptionMetafields').length > -1) {
        $('.product-form__descriptionMetafields .Collapsible__Button').click(function () {
            if (!$(this).hasClass('Collapsible__Button--scroll')) {
                $(this).toggleClass('is-active');
                $(this).parent().find('.Collapsible__Inner').slideToggle();
            }
        })
    }

    if ($('.template-product .js-sliderMoviesList').length > 0) {
        $('.js-sliderMoviesList').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '70px'
                }
            }]
        })
    }

    if ($('.template-product').length > 0) {
        $('.c-Variants__action button.button--addToCart').click(function (event) {
            const variantId = $(this).data('id');
            if ($('.product-form__buy-buttons form input[name="id"]').length > 0) {
                $('.product-form__buy-buttons form input[name="id"]').val(variantId);
            }
            $('#AddToCart').trigger("click");
            setTimeout(function () {
                $('.js-closeModalVariant').trigger("click");
            }, 500)
        })
        // サブスクリプションでは単品と定期便でformを出し分けする
        $('button.button--addToCart--single').click(function (event) {
            const variantId = $(this).data('id');
            $('.product-form__buy-buttons--single form[action="/cart/add"] input[name="id"]').val(variantId);
            $('#AddToCartSingle').trigger("click");
            setTimeout(function () {
                $('.js-closeModalVariant').trigger("click");
            }, 500)
        })
        $('button.button--addToCart--subscription').click(function (event) {
            const variantId = $(this).data('id');
            $('.product-form__buy-buttons--subscription form[action="/cart/add"] input[name="id"]').val(variantId);
            $('#AddToCartSubscription').trigger("click");
            setTimeout(function () {
                $('.js-closeModalVariant').trigger("click");
            }, 500)
        })

        $('.js-showModalVariants').click(function (event) {
            event.preventDefault();
            $('.product-form__variants.js-modal-addToCart').addClass('is-show');
            $('body').addClass('no-scroll');
        });
        $('.js-showModalInventory').click(function (event) {
            event.preventDefault();
            $('.product-form__variants.js-modal-inventory').addClass('is-show');
            $('body').addClass('no-scroll');
        });
        $('.js-closeModalVariant').click(function (event) {
            event.preventDefault();
            $('.product-form__variants').removeClass('is-show');
            $('body').removeClass('no-scroll');
        });

        // 店舗在庫モーダル: 店舗リストに店舗ごとの在庫サマリ（確認中 / 在庫あり / 在庫なし）を出す
        // 各バリアントの在庫テキスト（.c-Variants__inventory）は clubhers アプリが「読込中…」から書き換えるため、
        // その変更を監視して店舗単位に集約する
        const inventoryModal = document.querySelector('.js-modal-inventory');
        if (inventoryModal && 'MutationObserver' in window) {
            const summarizeStoreStock = function (texts) {
                if (texts.some(function (t) { return t === '在庫あり' || t === '残りわずか'; })) {
                    return 'in-stock';
                }
                if (texts.length > 0 && texts.every(function (t) { return t === '在庫なし' || t === 'お問い合わせ'; })) {
                    return 'out-of-stock';
                }
                return 'loading';
            };
            const storeStockLabels = { 'in-stock': '在庫あり', 'out-of-stock': '在庫なし', 'loading': '確認中' };
            const updateStoreStockSummary = function () {
                inventoryModal.querySelectorAll('.product-form__inventory__anchor li[data-store-id]').forEach(function (item) {
                    const summary = item.querySelector('.product-form__inventory__anchor-stock');
                    if (!summary) return;
                    const storeId = item.getAttribute('data-store-id');
                    // SKU 未設定のバリアントはアプリ側も取得しないので集計から外す
                    const cells = inventoryModal.querySelectorAll('.c-Variants__inventory[data-store-id="' + storeId + '"]:not([data-sku=""])');
                    const texts = Array.prototype.map.call(cells, function (cell) { return cell.textContent.trim(); });
                    const status = summarizeStoreStock(texts);
                    if (summary.getAttribute('data-status') !== status) {
                        summary.setAttribute('data-status', status);
                        summary.textContent = storeStockLabels[status];
                    }
                });
            };
            updateStoreStockSummary();
            new MutationObserver(updateStoreStockSummary).observe(inventoryModal, { childList: true, characterData: true, subtree: true });
        }

        if ($(window).width() <= 999) {
            $('.product__media-item').click(function () {
                $('.tap-area.product__zoom-button').trigger('click')
            })

            // 商品詳細ページのURLに「open_inventory_modal=true」パラメータが付いてたら、在庫モーダルを表示する
            let url = new URL(window.location.href);
            let params = url.searchParams;
            if (params.get('open_inventory_modal') == "true") {
                const intervalId = setInterval(() => {
                    const targetElement = document.querySelector(".js-modal-inventory");
                    if (targetElement) {
                        if (targetElement.classList.contains("is-show")) {
                            // チラツキ防止のため非表示にしていたbodyを表示する（戻す必要はないはずだが念のため
                            document.querySelector('body').style.display = "block";
                            clearInterval(intervalId);
                        } else {
                            // webviewのバックボタンと重複するのでcloseボタンを削除する
                            if (document.querySelector(".js-modal-inventory .product-form__variants--footer") != null) {
                                document.querySelector(".js-modal-inventory .product-form__variants--footer").remove();
                            }
                            // 在庫モーダルを表示する
                            // $('.js-showModalInventory').click();
                            // ↑の記述だとreactで設定したonClickのイベントハンドラが発火しないので↓の記述にしている
                            document.querySelector(".js-showModalInventory").dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                        }
                    }
                }, 500);
            }
        }
    }

    function smoothScroll(position, speed) {
        const startPosition = window.pageYOffset;
        const distance = position - startPosition;
        const startTime = performance.now();

        function scroll(timestamp) {
            const elapsed = timestamp - startTime;
            const scrollAmount = easeInOut(elapsed, startPosition, distance, speed);

            window.scrollTo(0, scrollAmount);

            if (elapsed < speed) {
                window.requestAnimationFrame(scroll);
            }
        }

        // イージング関数
        function easeInOut(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        window.requestAnimationFrame(scroll);
    }

    if ($('#js_to_target').length > 0) {
        const anchor = $('#js_to_target');
        const scrollSpeed = 5000; // スクロールの速度を指定

        anchor.click(function (event) {
            event.preventDefault();

            const header = document.querySelector('.header__wrapper').offsetHeight;

            // 各 anchor の href属性取得
            const href = anchor.attr("href");

            // topに戻る以外のアンカー
            if (href !== '#top') {

                // スクロール先の要素を取得 （アンカーの リンク先 #.. の # を取り除いた名前と一致する id名の要素）
                const target = document.querySelector('#review-target');

                // スクロール先の要素の位置を取得
                // header の高さ引く
                const position = window.pageYOffset + target.getBoundingClientRect().top - header;

                // スクロールアニメーション
                smoothScroll(position, 1000);

                // topに戻る
            } else {
                smoothScroll(0, 1000);
            }
        });
    }

    var checkEmptyWishlist = setInterval(function () {
        var $item = $('.swym-empty-wishlist-text');
        if ($item.length) {
            clearInterval(checkEmptyWishlist);
            $('.swym-empty-wishlist-text').html('お気に入りリストに商品を追加いただくと、もう一度商品を購入される際などに便利です。商品画像の右下にある ハートマーク をクリックしてお気に入りに追加ください。')
        }
    }, 100); // check every 100ms
});

document.addEventListener('DOMContentLoaded', function() {
    const ua = navigator.userAgent;
    const url = new URL(window.location.href);
    const params = url.searchParams;
    // アプリwebview用の処理
    if (ua.indexOf("herliptoWebview") != -1) {
        // 注文一覧用
        if (url.pathname == "/account") {
            if (params.get('only_orderlist') == "true") {
                const links = document.querySelectorAll("page-pagination a");
                if (links != null) {
                    links.forEach(link => {
                        link.href += "&only_orderlist=true";
                    });
                }
            }
        }
        // 注文詳細用
        if (url.pathname.startsWith("/account/orders/")) {
            const links = document.querySelectorAll('a[href="/account"]');
            links.forEach(link => {
                link.href += "?only_orderlist=true";
            });
        }
    }
});